// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarOrcamentosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/buscar_orcamentos
 *
 * No body required — endpoint reads approved orcamentos scoped by the
 * authenticated user's franchise permissions, not the request payload.
 */
import { registerContract } from './validate'

export interface Agenda_BuscarOrcamentosInput {}

registerContract('Agenda_BuscarOrcamentosInput', {})
